<style scoped>
.ipt-sty {
  width: 70% !important;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <p class="t-left font-S14 fontC-4fa1a4 mb20" v-show="$route.query.pageTitle">{{$route.query.pageTitle}}</p>
      <el-row :gutter="20">
        <el-col :span="7"
          ><div class="search-area-div">名称：</div>
          <el-input v-model="page.organisationName" class="ipt-sty" placeholder="请输入名称" :clearable="true"></el-input
        ></el-col>
        <el-col :span="7">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加组织</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <div class="fr line-h40 h40 font-S16 mr16">有<b class="fontC-4fa1a4"> {{page.totalRows}} </b>个组织</div>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class="back-color-fff" style="padding: 16px">
      <el-table
        :data="treeData"
        style="width: 100%; margin-bottom: 20px"
        row-key="guid"
        border
        @selection-change="handleSelectionChange"
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        v-loading="loading"
        @expand-change="expandChange"
        :expand-row-keys="expandRowKeys"
      >
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <!-- <el-table-column label="序号" width="60" header-align="center" align="center">
                <template slot-scope="scope">
                    {{scope.$index+1}} 
                </template>
        </el-table-column> -->
        
        <el-table-column prop="organisationName" label="名称" header-align="center" align="left"> </el-table-column>
        <el-table-column prop="orderNum" label="排序" width="100" header-align="center" align="center"> </el-table-column>
        <!-- <el-table-column prop="bizState" label="状态" header-align="center" align="center"> </el-table-column> -->
        <el-table-column prop="bizState" label="状态" width="100" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.bizState | getBizState }}</template>
        </el-table-column>
        <el-table-column prop="createUserNameNew" label="创建人" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createUserNameNew || '-' }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="updateUserNameNew" label="更新人" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateUserNameNew || '-' }}</template>
        </el-table-column>
       <!--  <el-table-column  label="推广区域"  header-align="center" align="left" show-overflow-tooltip>
          <template slot-scope="scope">{{ areaD}}</template>
        </el-table-column> -->
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <!-- <a class="txt-color" @click="showArea(scope.row.guid)">维护推广区域 | </a> -->
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination> -->
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <!-- <el-form-item label="组织编码:" prop="organisationCode">
          <el-input v-model="ruleForm.organisationCode" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="组织名称:" prop="organisationName">
          <el-input v-model="ruleForm.organisationName" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <!-- <el-form-item label="联系电话:" prop="contactTel">
          <el-input v-model="ruleForm.contactTel" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <el-form-item label="省市县:">
          <citys @incre="incres" :workareaList.sync="workareaList"></citys>
        </el-form-item> -->
        <!-- <el-form-item label="地点:">
          <el-input v-model="ruleForm.venue" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="地址:">
          <el-input v-model="ruleForm.address" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="上级组织:">
          <el-cascader
            class="w100f"
            v-model="ruleForm.parentGuid"
            placeholder="请选择"
            :options="superiorOrganization"
            :show-all-levels="false"
            :props="{
              value: 'guid',
              label: 'organisationName',
              children: 'children',
              checkStrictly: true,
            }"
            ref="cascader"
            clearable
            @change="getLevel"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="序号:" prop="orderNum">
          <el-input v-model="ruleForm.orderNum" autocomplete="off" class="w100f"></el-input>
        </el-form-item>
        <!-- <el-form-item label="运营单元:" class="t-left"> 
          <el-select v-model="ruleForm.operationUnitGuid" filterable placeholder="请选择" clearable class="w100f" multiple collapse-tags>
            <el-option
              v-for="item in businessUnitList"
              :key="item.guid"
              :label="item.operationUnitName"
              :value="item.guid">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="层级:" prop="level">
          <el-input v-model="ruleForm.level" autocomplete="off" class="w100f"></el-input>
        </el-form-item> -->
        <el-form-item label="核算单元:" prop="bizUnitGuid">
          <div style="display:flex;">
             <el-select :clearable="true" v-model="ruleForm.bizUnitGuid" placeholder="请选择" style="width:70%;margin-right:20px;">
            <el-option
              v-for="item in bizUnitNameOptions"
              :key="item.guid"
              :label="item.label"
              :value="item.guid">
            </el-option>
          </el-select>
          <el-checkbox v-model="ruleForm.updateUnitChild">下级部门同时修改</el-checkbox>
        </div>
          
        </el-form-item>

        <!-- start of 分配企业(药企服务事业部的时候才展示出来) -->
        <!-- <el-form-item
          label="分配企业:"
          v-if="ruleForm.parentGuid === '9ec5bc8798d9adca127becb33917cffb'"
          prop="distributeTenantList"
          :rules="[
            { required: true, message: '请选择分配企业', trigger: 'blur' },
          ]"
        > -->
        <!-- <el-form-item
          label="分配企业:"
          prop="distributeTenantList"
        >
          <el-select
            class="w100f"
            placeholder="请选择"
            multiple
            collapse-tags
            filterable
            v-model="ruleForm.distributeTenantList"
          >
            <el-option
              v-for="item in organizationOption"
              :key="item.sendTenantGuid"
              :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- end of 分配企业 -->

        <el-form-item label="业务状态:" class="t-left">
          <el-radio v-model="ruleForm.bizState" label="Y">有效</el-radio>
          <el-radio v-model="ruleForm.bizState" label="S">停用</el-radio>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '添加组织'" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="维护推广区域" :visible.sync="dialogArea" width="550px">
      <div>
        <span>推广区域：</span
        ><el-cascader :options="options" v-model="areaData"	 :props="{ multiple: true}" clearable></el-cascader>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogArea = false">取消</el-button>
        <el-button size="medium" type="info" @click="submitAreaData">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import citys from '../../components/citys.vue';
import areaJson from '../../assets/js/china_address_v4.js';
export default {
  components: {
    citys,
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        console.log(reg.test(value));
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };
    return {
      options: areaJson,
      areaData:[],
      areaD:[],
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      workareaList: '',
      dialogArea: false,
      ruleForm: {
        guid: '',
        tenantGuid: '',
        // organisationCode: '',
        organisationName: '',
        contactTel: '',
        // province: '',
        // city: '',
        // district: '',
        // venue: '',
        // address: '',
        bizState: 'Y',
        parentGuid: '',
        orderNum: '',
        level: 0,
        bizUnitGuid:"",
        updateUnitChild:false
      },
      page: {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '', 
        organisationName: '', 
      },
      loading:false,
      treeData: [],
      superiorOrganization: [],
      rules: {
        // organisationCode: [
        //   { required: true, message: '请输入组织编码', trigger: 'blur' },
        //   { min: 1, max: 30, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        // ],
        organisationName: [
          { required: true, message: '请输入组织名称', trigger: 'blur' },
          { min: 1, max: 60, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        // contactTel: [
        //   { required: true, validator: checkPhone, message: '请输入联系电话', trigger: 'blur' },
        //   { min: 1, max: 11, message: '请输入联系电话', trigger: 'blur' },
        // ],
        orderNum: [
          { required: true, message: '请输入序号', trigger: 'blur' },
          { min: 1, max: 10000, message: '请输入序号', trigger: 'blur' },
        ],
        // level: [
        //   { required: true, message: '请输入序号', trigger: 'blur' },
        //   { min: 1, max: 10000, message: '请输入序号', trigger: 'blur' },
        // ],
        // parentGuid: [{
        //     type: 'array',
        //     required: true,
        //     message: '请选择上级组织',
        //     trigger: 'blur'
        // }]
      },
      bizUnitNameOptions:[],
      multipleSelection: [],
      tenantGuid: '', //企业id
      tenantName: this.$route.query.tenantName, 
      expandRowKeys:[],

      organizationOption: []
    };
  },
  created() {
    // 列表
    this.getData(false);
    this.getSuperiorOrganization();
    this.getbizUnitNameOptions();

    this.getOrganizationOption();
  },
  methods: {
    getOrganizationOption() {
      let self = this;
      let query = {
        isService: true, // true=获取我服务的企业 false=获取服务于我的企业
        tenantGuid: self.$store.getters.getTenantGuid
      };
      self.api.get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
         var list = res.data.data || [];
         self.organizationOption = list
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getbizUnitNameOptions() {
      let self = this;
      let page = {
        pageIndex: 1,
        pageSize: -1,
        tenantGuid: self.$store.getters.getTenantGuid
      };
      self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-unit/data/get-biz-unit`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
         var list = res.data.data.records;
         self.bizUnitNameOptions = list
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    //直辖市转
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0, 
        tenantGuid: '', 
        organisationName: '', 
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.loading = true;
      self.treeData = [];
      self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, self.page).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = res.data.data.records;
          self.loading = false;
          if(data != null && data != ''){
            data.forEach(function (item) {
              if (item.parentGuid == '' || item.parentGuid == null) {
                self.treeData.push(item);
                self.AddChildren(item, data);
              }
            });
          }
          //  if(row.colC == '市辖区' || row.colC == '县'){
          //          row.colC = row.colB
          //   }
          if(self.tableData != null && self.tableData != ''){
              self.tableData.forEach(function(i){
                areaJson.forEach(function(j){
                  if(i.province == j.value){
                      i.province = j.label
                  }
                 })
              }) 
          } 
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = self.treeData.length;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    // 行展开关闭
    expandChange(row, expandedRows){
      if(expandedRows){
        if(this.expandRowKeys && this.expandRowKeys.length > 0){
          let flg = false;
          this.expandRowKeys.forEach(i =>{
            if(row.guid == i){
              flg = true;
            }
          })
          if(!flg){
            this.expandRowKeys.push(row.guid);
          }
        }else{
          this.expandRowKeys.push(row.guid);
        }
        
      }else{
        this.expandRowKeys.forEach((i,index) =>{
          if(i.guid == row.guid){
            this.expandRowKeys.splice(index,1);
          }
        })
      }
      console.log('展开',this.expandRowKeys)
    },
    //维护推广区域
    showArea(guid) {
      let self = this;
      self.dialogArea = true;
    },
    //提交推广区域
    submitAreaData(){
      let self = this;
      self.dialogArea = false;
      self.areaD = self.areaData;
    },
    getSuperiorOrganization() {
      let self = this;
      let tenantGuid = self.$store.getters.getTenantGuid;
      self.api
        .get(`/${serverConfig.msPersonnelService}/organisation/data/get-organisation-detail?` + `tenantGuid=` + tenantGuid)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.superiorOrganization = res.data.data;
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    //加载子节点
    AddChildren: function (item, elems) {
      for (let i = 0; i < elems.length; i++) {
        let elem = elems[i];
        if (elem.parentGuid == item.guid) {
          if (item) {
            item.children ? item.children.push(elem) : (item.children = [elem]);
          }
          this.AddChildren(elem, elems);
        }
      }
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/delete`, self.multipleSelection).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('删除成功！');
              if(self.expandRowKeys && self.expandRowKeys.length > 0){
                self.expandRowKeys.forEach((i,index1)=>{
                  self.multipleSelection.forEach((j,index2)=>{
                    if (i === j) {
                      self.expandRowKeys.splice(index1, 1, "del")
                    }
                  })
                })
                self.expandRowKeys= self.expandRowKeys.filter(item => item !== "del")
              }
              self.multipleSelection = [];
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(flg, row) {
      let self = this;
      self.getSuperiorOrganization();
      self.workareaList = [];
      self.ruleForm.parentGuid = '';
      if (flg == 1) {
        self.textTitle = '添加组织';
        self.ruleForm.tenantGuid = '';
        // self.ruleForm.organisationCode = '';
        self.ruleForm.organisationName = '';
        // self.ruleForm.contactTel = '';
        // self.ruleForm.province = '';
        // self.ruleForm.tenantGuid = '';
        // self.ruleForm.city = '';
        // self.ruleForm.district = '';
        // self.ruleForm.venue = '';
        // self.ruleForm.address = '';
        self.ruleForm.bizState = 'Y';
        self.ruleForm.orderNum = '';
        self.ruleForm.level = 0;
        self.ruleForm.bizUnitGuid ="";
        self.ruleForm.updateUnitChild = false;
        
        self.$set(self.ruleForm, 'distributeTenantList', '');
      } else {
        self.textTitle = '编辑组织';
        console.log(row);
        self.ruleForm.guid = row.guid;
        self.ruleForm.tenantGuid = row.tenantGuid;
        // self.ruleForm.organisationCode = row.organisationCode;
        self.ruleForm.organisationName = row.organisationName;
        // self.ruleForm.contactTel = row.contactTel;
        // self.ruleForm.province = row.province;
        // self.ruleForm.tenantGuid = row.tenantGuid;
        // self.ruleForm.city = row.city;
        // self.ruleForm.district = row.district;
        // self.ruleForm.venue = row.venue;
        // self.ruleForm.address = row.address;
        self.ruleForm.orderNum = row.orderNum;
        self.ruleForm.level = Number(row.level);
        self.ruleForm.bizState = row.bizState;
        self.workareaList.push(row.province, row.city, row.district);
        self.ruleForm.parentGuid = row.parentGuid;
        self.ruleForm.bizUnitGuid = row.bizUnitGuid;
        self.ruleForm.updateUnitChild = false;

        self.$set(self.ruleForm, 'distributeTenantList', '');
        // 如果有分配企业信息，则需要处理数据格式
        if(row.distributeTenantList) {
          self.ruleForm.distributeTenantList = row.distributeTenantList.map(item => item.guid)
        }
      }
      self.dialogFormVisible = true;
    },
    incres(area) {
      let self = this;
      self.ruleForm.province = area[0];
      self.ruleForm.city = area[1];
      self.ruleForm.district = area[2];
    },
    submitForm(formName) {
      let self = this;
      var bizUnitName;

      var bizUnitNameOptions =  this.bizUnitNameOptions;
      var filterArr =[];
      if(bizUnitNameOptions&&bizUnitNameOptions.length>0){
        filterArr =  bizUnitNameOptions.filter(item=>item.guid == self.ruleForm.bizUnitGuid )
      }

      
      // 分配企业字段，处理数据格式
      let list = self.ruleForm.distributeTenantList || [];
      let distributeTenantList = [];
      list.forEach(item => {
        self.organizationOption.forEach(citem => {
          if(item == citem.sendTenantGuid) {
            distributeTenantList.push({
              guid: citem.sendTenantGuid,
              name: citem.sendTenantName
            })
          }
        })
      })

      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            tenantGuid: self.page.tenantGuid,
            // organisationCode: self.ruleForm.organisationCode,
            organisationName: self.ruleForm.organisationName,
            // contactTel: self.ruleForm.contactTel,
            // province: self.ruleForm.province,
            // city: self.ruleForm.city,
            // district: self.ruleForm.district,
            // venue: self.ruleForm.venue,
            // address: self.ruleForm.address,
            bizState: self.ruleForm.bizState,
            parentGuid: self.ruleForm.parentGuid.toString(),
            orderNum: self.ruleForm.orderNum,
            bizUnitGuid: self.ruleForm.bizUnitGuid,
            bizUnitName:filterArr.length>0&&filterArr[0].label||null,
            updateUnitChild:self.ruleForm.updateUnitChild,
            level: Number(self.ruleForm.level),
            distributeTenantList: distributeTenantList
          };
          self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/add`, promise).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('添加组织架构成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      if (self.ruleForm.parentGuid == null) {
        self.ruleForm.parentGuid = '';
      }
      var bizUnitName;
      var bizUnitNameOptions =  this.bizUnitNameOptions;
      var filterArr =[];
      if(bizUnitNameOptions&&bizUnitNameOptions.length>0){
        filterArr =  bizUnitNameOptions.filter(item=>item.guid == self.ruleForm.bizUnitGuid )
      }

      // 分配企业字段，处理数据格式
      let list = self.ruleForm.distributeTenantList || [];
      let distributeTenantList = [];
      list.forEach(item => {
        self.organizationOption.forEach(citem => {
          if(item == citem.sendTenantGuid) {
            distributeTenantList.push({
              guid: citem.sendTenantGuid,
              name: citem.sendTenantName
            })
          }
        })
      })

      self.$refs[formName].validate((valid) => {
        if (valid) {
          let promise = {
            guid: self.ruleForm.guid,
            tenantGuid: self.page.tenantGuid,
            // organisationCode: self.ruleForm.organisationCode,
            organisationName: self.ruleForm.organisationName,
            // contactTel: self.ruleForm.contactTel,
            // province: self.ruleForm.province,
            // city: self.ruleForm.city,
            // district: self.ruleForm.district,
            // venue: self.ruleForm.venue,
            // address: self.ruleForm.address,
            bizState: self.ruleForm.bizState,
            bizUnitGuid: self.ruleForm.bizUnitGuid,
            bizUnitName:filterArr.length>0&&filterArr[0].label||null,
            updateUnitChild: self.ruleForm.updateUnitChild,

            parentGuid: self.ruleForm.parentGuid.toString(),
            orderNum: self.ruleForm.orderNum,
            level: Number(self.ruleForm.level),
            distributeTenantList: distributeTenantList
          };
          self.api.put(`/${serverConfig.msPersonnelService}/organisation/data/update`, promise).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('编辑组织架构成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
    getLevel(val) {
      let self = this;
      console.log('789', val, val.length);
      self.ruleForm.level = '';
      if (val.length > 0) {
        self.ruleForm.parentGuid = val[val.length - 1].toString();
        self.ruleForm.level = val.length;
      } else {
        self.ruleForm.level = 0;
      }
    },
  },
};
</script>
